export * from './datei-arts-list.component';
export * from './datei-arts-list.component.module';